import React, { useState } from "react";
import * as formatacoes  from '../../util/formatacoes';


const Table = ({ data }) => {


    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (key) => {
        setExpandedRows((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const renderMainRow = (data_completa, city, tipoNegocio, tipos) => {
        const key = `${city}-${tipoNegocio}-${data_completa}`;
        const isOpen = expandedRows[key];
        const [ano, mes, dia] = data_completa.split('-');

        const mesAnoFormatado = `${mes}/${ano}`;

        const total = Object.values(tipos).reduce((sum, tipo) => sum + (tipo.total || 0), 0);

        const online = Object.values(tipos).reduce((sum, tipo) => sum + (tipo.online || 0), 0);
        const off = Object.values(tipos).reduce((sum, tipo) => sum + (tipo.off || 0), 0);

        const icon = isOpen ? (
            <i className="fa-solid fa-arrow-up" style={{ marginRight: "8px" }}></i>
        ) : (
            <i className="fa-solid fa-arrow-down" style={{ marginRight: "8px" }}></i>
        );

        return (
            <React.Fragment key={key}>
                <tr
                    onClick={() => toggleRow(key)}
                    className="text-center"
                >
                    <td><strong>{icon}{city} </strong></td>
                    <td>{tipoNegocio}</td>
                    <td>{mesAnoFormatado}</td>
                    <td>{formatacoes.formatNumber(total)}</td>
                    <td>{formatacoes.formatNumber(online)}</td>
                    <td>{formatacoes.formatNumber(off)}</td>
                </tr>
                {isOpen && renderTipos(tipos, tipoNegocio, mesAnoFormatado)}
            </React.Fragment>
        );
    };

    const renderTipos = (tipos, tipoNegocio, mesAnoFormatado) => {
        return Object.entries(tipos).map(([tipo, valores]) => (
            <tr key={tipo} className="text-center">
                <td style={{ paddingLeft: "2rem" }}>↳ {tipo}</td>
                <td>{tipoNegocio}</td>
                <td>{mesAnoFormatado}</td>
                <td>{formatacoes.formatNumber(valores.total)}</td>
                <td>{formatacoes.formatNumber(valores.online)}</td>
                <td>{formatacoes.formatNumber(valores.off)}</td>
            </tr>
        ));
    };

    const agrupamento = data.total_por_cidade_tipo_negocio_tipo_periodo;


    if (!agrupamento) {
        return <p>Sem dados disponíveis.</p>;
    }

    return (
        <table className="table table-striped table-condensed table-padroes">
            <thead>
                <tr className="text-center" style={{ backgroundColor: '#1e78b4', color: "#ffffff", fontWeight: "bold", }}>
                    <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Cidade</th>
                    <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Tipo de Negócio</th>
                    <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Período</th>
                    <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Total</th>
                    <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Online</th>
                    <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Offline</th>
                </tr>
            </thead>
            <tbody>

                {Object.entries(agrupamento).map(([cidade, data_completa]) =>
                    Object.entries(data_completa).map(([data, tiposNegocio]) =>
                        Object.entries(tiposNegocio).map(([tipoNegocio, tipos]) =>
                            renderMainRow(data, cidade, tipoNegocio, tipos)
                        )
                    )
                )}
            </tbody>
        </table>
    );
};

export default Table;
